import React from 'react';
import { IconButtonProps, Text } from '@chakra-ui/react';
import { ClipboardIconButton, ClipboardRoot } from '@/components/ui/clipboard';

interface CopyButtonProps extends IconButtonProps {
  copyVal: string;
}

export const CopyButton = ({ copyVal, ...props }: CopyButtonProps) => {
  if (copyVal) {
    return (
      <ClipboardRoot value={copyVal}>
        <ClipboardIconButton {...props} />
      </ClipboardRoot>
    );
  }

  return <Text visibility='hidden' />;
};
